var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionTabBarGoalsIconOnlyDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h35v21H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.907 10.5 2.04-2.795a.774.774 0 0 0 .067-.794.73.73 0 0 0-.66-.418h-3.955a.732.732 0 0 0-.593.302l-2.368 3.246c-.2.267-.2.637 0 .911l2.374 3.247c.14.191.36.301.594.301h3.954c.28 0 .534-.164.66-.418a.774.774 0 0 0-.066-.794L27.907 10.5zM18.957 9.74h1.708c-.36-2.808-2.708-4.98-5.535-4.98-3.081 0-5.589 2.576-5.589 5.74s2.508 5.74 5.589 5.74c2.827 0 5.174-2.172 5.535-4.98h-1.708c-.346 1.85-1.934 3.247-3.827 3.247-2.154 0-3.902-1.795-3.902-4.007 0-2.212 1.748-4.007 3.902-4.007 1.893 0 3.48 1.397 3.827 3.247z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.632 15.11-1.774-2.425c-.907 2.938-3.58 5.068-6.735 5.068-3.895 0-7.062-3.253-7.062-7.253s3.167-7.253 7.062-7.253c3.154 0 5.828 2.13 6.735 5.068l1.774-2.425c.127-.178.28-.328.447-.458C22.339 2.192 18.977 0 15.123 0 9.475 0 4.9 4.705 4.9 10.5S9.475 21 15.123 21c3.854 0 7.215-2.192 8.956-5.432-.167-.13-.32-.28-.447-.458z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.123 9.74h2.307c-.313-1-1.227-1.733-2.307-1.733-1.334 0-2.427 1.116-2.427 2.493 0 1.377 1.087 2.493 2.427 2.493 1.08 0 1.994-.726 2.307-1.733h-2.307a.753.753 0 0 1-.74-.76c.006-.425.333-.76.74-.76z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionTabBarGoalsIconOnlyDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-tab-bar-goals-icon-only-default.c1287bc6700f2f3370bf94b4dc0a3a67.svg";